import { createApp } from 'vue';
const lists = document.querySelectorAll('.webien-product-list-app');

lists.forEach((list) => {
    const texts = document.getElementById('productListTexts-' + list.dataset.unique);
    let textObserver;

    let $app = createApp({
        name: "productList-" + list.dataset.unique,
        data() {
            return {
                settings: [],
                products: [],
                templates: [],
                showAllProducts: false,
                ready: false,
                order: 'none',
                filter: {
                    safety: 'all',
                    serie: 'all',
                    material: 'all',
                    color: 'all',
                    adjustableHeight: 'all',
                }
            }
        },
        mixins: [

        ],
        computed: {
            mainList() {

                if(!this.settings.sections || this.settings.sections.length === 0) return ([]);



                let list = {
                    visible: [],
                    more: []
                };

                let products = this.products.slice();

                // Apply filters
                //....


                // Apply oder
                if(this.order === 'name-ASC'){
                    products = products.sort((a,b) => (a.heading > b.heading) ? 1 : ((b.heading > a.heading) ? -1 : 0))
                }
                else if(this.order === 'name-DESC'){
                    products = products.sort((a,b) => (a.heading < b.heading) ? 1 : ((b.heading < a.heading) ? -1 : 0))
                }
                else if(this.order === 'price-ASC'){
                    products = products.sort((a,b) => (a.price > b.price) ? 1 : ((b.price > a.price) ? -1 : 0))
                }
                else if(this.order === 'price-DESC'){
                    products = products.sort((a,b) => (a.price < b.price) ? 1 : ((b.price < a.price) ? -1 : 0))
                }



                // If favorites, only use the ones in local storage
                if(this.settings.view === 'favorites'){
                    let favorites = localStorage.getItem('webienProductFavorites');

                    if(favorites){
                        favorites = JSON.parse(favorites);
                    }

                    if(favorites && Array.isArray(favorites)){
                        // Limit products only to favorites, if fastening option exist in storage, match that as well
                        products = products.filter(product => {
                            let fav = favorites.find(favItem => {
                                if(favItem.fastening){
                                    return favItem.id === product.id && parseFloat(favItem.fastening) === product.fastening_option;
                                } else {
                                    return favItem.id === product.id;
                                }
                            });
                            return typeof fav !== 'undefined';
                        });
                    } else {
                        products = [];
                    }

                }

                // Insert sections as stated in settings
                this.settings.sections.forEach((section) => {
                    if(section.type === 'products'){
                        // Slice products from product list and insert to items
                        let count = section.product_count || 4;
                        if(count === -1) count = products.length;
                        let sliced = products.splice(0, count);
                        list.visible = list.visible.concat(sliced);
                    }
                    if(section.type === 'template'){
                        // Find template by id
                        let template = this.templates.find(t => t.id === section.template);
                        if(template){
                            list.visible.push(template);
                        }
                    }
                });


                if(this.showAllProducts){
                    // If showing all, add remaining products to visible
                    list.visible = list.visible.concat(products);
                    products = [];
                } else {
                    // If not showing all, add remaining products to more
                    list.more = products;
                    products = [];
                }


                return list;

            }

        },
        watch: {

        },
        methods: {
            refresh() {
                let $vue = this;
                const headings = new Map();
                if (texts) {
                    texts.querySelectorAll('[data-product-key]').forEach((el) => {
                        headings.set(el.dataset.productKey, el.innerHTML);
                    });
                }
                $vue.products = (window['productList_' + list.dataset.unique] || []).map((product) => ({
                    ...product,
                    heading: headings.get(String(product.combined_id)) ?? product.heading,
                }));
            },
            updateOrder(newOrder) {
                this.order = newOrder;
            },
            showAll() {
                this.showAllProducts = true;
            },
            // Campaign in the visitor's market, item.campaigns are locales from Market\Price::campaignLocales()
            hasCampaign(item) {
                return Array.isArray(item.campaigns) && !!window.rbMarket && item.campaigns.indexOf(window.rbMarket.locale) !== -1;
            },
            // Link on the visitor's domain/language path, see market.js
            localUrl(url) {
                return window.rbLocalUrl ? window.rbLocalUrl(url) : url;
            }

        },
        mounted: function () {
            let $vue = this;

            this.refresh();
            this.settings = window['widgetSettings_' + list.dataset.unique];
            this.templates = window['templateList_' + list.dataset.unique];

            this.ready = true;

            // Also pick up translations applied after mounting or when switching language.
            if (texts) {
                textObserver = new MutationObserver(() => $vue.refresh());
                textObserver.observe(texts, { childList: true, characterData: true, subtree: true });
            }

            window.addEventListener(
                "refreshPostList",
                (e) => {
                    $vue.refresh();
                },
                false,
            );

        },
        created() {

        },
        beforeUnmount() {
            if (textObserver) {
                textObserver.disconnect();
            }
        },
        components: {
        },
    });

    // Mount app to DOM
    if(document.getElementById('productList-' + list.dataset.unique)){
        $app.mount('#productList-' + list.dataset.unique);
    }

});
